<template>
  <header class="event-modal-catalog-header">
    <div class="event-modal-catalog-header__top">
      <h1 class="event-modal-catalog-header__info-title">
        {{ $t("event.catalog.title") }}
      </h1>

      <div class="event-modal-catalog-header__info-box">
        <EventModalCatalogManager :managers="managers" />
        <div class="event-modal-catalog-header__info-text">
          <span>
            {{
              $t("event.catalog.deadlineInfo", {
                date: endCatalogOrderDate.format("DD MMMM YYYY")
              })
            }}
          </span>
          <EventModalCatalogExample
            :label="false"
            :images="['/static/catalog-order/catalog-minimum-example.jpg']"
          />
        </div>
      </div>

      <div class="event-modal-catalog-header__info-toggler">
        <LinkIcon
          icon="doc"
          grey
          bold
          :href="infoFilepath"
          target="_blank"
          class="event-modal-catalog-header__info-toggler-text"
        >
          {{ $t("event.catalog.modal.infoTogglerTitle") }}
        </LinkIcon>

        <button
          v-if="step === steps.PREVIEW && !errorPriceServices"
          class="event-modal-catalog-header__print-order"
          :class="{
            'event-modal-catalog-header__print-order--loading': isCatalogLoading
          }"
          @click="downloadOrder"
        >
          <LoadingIcon
            v-if="isCatalogLoading"
            class="event-modal-catalog-header__preloader"
          />
          <icon name="download-no-color" />
          {{ $t("event.catalog.modal.preview.downloadOrder") }}
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment/moment";
import apiCatalog from "@/api/catalog";
import EventModalCatalogManager from "@/components/Modal/Catalog/EventModalCatalogManager.vue";
import EventModalCatalogExample from "@/components/Modal/Catalog/EventModalCatalogExample.vue";
import { LinkIcon, LoadingIcon } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";

export default {
  name: "EventModalCatalogHeader",
  components: {
    EventModalCatalogExample,
    EventModalCatalogManager,
    LinkIcon,
    LoadingIcon
  },
  data() {
    return {
      isCatalogLoading: false
    };
  },
  computed: {
    ...mapState("event", ["event"]),
    ...mapState("eventCatalog", ["step", "steps", "info"]),

    ...mapGetters("eventCatalog", ["errorPriceServices", "managers"]),

    infoFilepath() {
      return `/static/docs/general_terms_of_publication_in_the_official_catalogue_guide_${
        i18n.locale === "en" ? "en" : "ru"
      }.pdf`;
    },
    endCatalogOrderDate() {
      return moment(this.info.catalog_order_ended_at).locale(i18n.locale);
    }
  },
  methods: {
    async downloadOrder() {
      this.isCatalogLoading = true;
      const response = await apiCatalog.downloadOrder(
        this.event.id,
        this.event.catalog_order_id
      );
      let blob = new Blob([response], {
        type: "application/pdf"
      });
      const url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = url;
      link.download =
        "Заявка на размещение в официальном каталоге и путеводителе.pdf";
      link.click();
      this.isCatalogLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-catalog-header {
  background: #fff;

  &__top {
    width: 780px;

    padding: 56px 0 50px 80px;

    @include respond-down(lg) {
      padding: 48px 24px;
      width: 100%;
      box-sizing: border-box;
    }

    @include respond-down(md) {
      padding: 24px 16px;
      flex-wrap: wrap;
    }
  }

  &__preloader {
    position: absolute;
    right: 25%;
    color: #009ee3;
  }

  &__info {
    width: 390px;
    &-box {
      display: flex;
      justify-content: space-between;
      @include respond-down(md) {
        flex-direction: column;
      }
    }
    &-text {
      max-width: 50%;
      line-height: 1.54;
      margin-top: 12px;
      @include respond-down(md) {
        max-width: 100%;
      }
    }
    &-title {
      @include h1();
      margin-bottom: 37px;

      @include respond-down(md) {
        margin-bottom: 24px;
      }
    }

    &-toggler {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      margin-top: 20px;

      &-text {
        margin-right: 30px;
      }
    }
  }

  &__print-order {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: center;
    margin: 10px 0;
    padding: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    background-color: transparent;
    border: none;
    box-shadow: none;
    outline: none;
    color: #009ee3;
    cursor: pointer;
    position: relative;

    &--loading {
      color: #cdced0;
      pointer-events: none;
    }

    @media (max-width: 739px) {
      font-size: 12px;
    }

    .svg-icon {
      max-width: 18px;
      max-height: 18px;
      margin-right: 10px;

      @media (max-width: 739px) {
        max-width: 16px;
        max-height: 16px;
      }
    }

    &-wrap {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-content: flex-start;
      align-items: center;
      margin-top: 50px;
    }
  }
}
</style>
